import HeaderLogoCircleK from '../../../../../customized/circle-k/theme/ui/Layout/Header/HeaderLogo/HeaderLogo';
import HeaderLogoDev from '../../../../../customized/flexeserve-dev/theme/ui/Layout/Header/HeaderLogo/HeaderLogo';
import HeaderLogoMorrison from '../../../../../customized/morrison/theme/ui/Layout/Header/HeaderLogo/HeaderLogo';
import HeaderLogoQuiktrip from '../../../../../customized/quiktrip/theme/ui/Layout/Header/HeaderLogo/HeaderLogo';
import { ToggleComponent } from '../../../../../shared/featureToggle';
import HeaderLogo from './HeaderLogo';

export default ToggleComponent(HeaderLogo, {
  StyledComponentsVariants: {
    'circle-k': HeaderLogoCircleK,
    'flexeserve-dev': HeaderLogoDev,
    morrison: HeaderLogoMorrison,
    quiktrip: HeaderLogoQuiktrip,
  },
});
